import { render, staticRenderFns } from "./AdminApplications.vue?vue&type=template&id=d8f52324&scoped=true&"
import script from "./AdminApplications.vue?vue&type=script&lang=ts&"
export * from "./AdminApplications.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d8f52324",
  null
  
)

export default component.exports